"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _validate = _interopRequireDefault(require("../validate"));

function setValue(value) {
  return (0, _validate["default"])({
    name: 'onSetValue',
    realTarget: function realTarget(action) {
      return action.target;
    },
    "do": function _do() {
      return value;
    }
  });
}

var _default = setValue;
exports["default"] = _default;